// 属性值输入方式：旧和新一样
export const extValueTypeEnum = {
    NUMBER: 1,
    TEXT: 2,
    RADIO: 3,
    MULTI: 4,
};
export const extValueTypeMap = {
    1: '数字输入',
    2: '文本输入',
    3: '单选',
    4: '多选',
};
export const extValueTypeOptions = [
    {
        label: '数字输入',
        value: 1,
    },
    {
        label: '文本输入',
        value: 2,
    },
    {
        label: '单选',
        value: 3,
    },
    {
        label: '多选',
        value: 4,
    },
];

// 是否可用：旧和新通用
export const usableTypeEnum = {
    DISABLE: 0,
    ENABLE: 1,
};

// 属性类型第一部分：旧
export const businessTypeEnum4Sku = {
    1: '基础属性',
    2: '销售规格',
    3: '经营属性',
    4: '运营属性',
    7: '验收属性',
};
export const businessTypeMap4Sku = {
    BASE: 1,
    SELL: 2, // 旧和新通用->页面中businessTypeMap.SELL可以用于判断新属性类型是否是销售规格
    MANAGE: 3,
    OPERATION: 4,
    ACCEPTANCE: 7,
};
export const businessTypeOptions4Sku = [
    {
        label: '基础属性',
        value: 1,
    },
    {
        label: '销售规格',
        value: 2,
    },
    {
        label: '经营属性',
        value: 3,
    },
    {
        label: '运营属性',
        value: 4,
    },
    {
        label: '验收属性',
        value: 7,
    },
];

// 属性类型第二部分：旧
export const businessTypeEnum4Poi = {
    5: '售卖属性',
    6: '采购属性',
};
export const businessTypeMap4Poi = {
    SALE: 5,
    PURCHASE: 6,
};
export const businessTypeOptions4Poi = [
    {
        label: '售卖属性',
        value: 5,
    },
    {
        label: '采购属性',
        value: 6,
    },
];

// 属性类型的组合信息：旧
export const businessTypeEnum = {
    ...businessTypeEnum4Sku,
    ...businessTypeEnum4Poi,
};
export const businessTypeMap = {
    ...businessTypeMap4Sku,
    ...businessTypeMap4Poi,
};
export const businessTypeOptions = [].concat(
    businessTypeOptions4Sku,
    businessTypeOptions4Poi,
);

// 属性类型：新
export const extTypeEnum = {
    1: '基础属性',
    2: '销售规格',
    3: '售卖属性',
    4: '采购属性',
    5: '内容属性',
    6: '仓储属性',
};
export const extTypeOptions = [
    {
        label: '基础属性',
        value: 1,
    },
    {
        label: '销售规格',
        value: 2,
    },
    {
        label: '售卖属性',
        value: 3,
    },
    {
        label: '采购属性',
        value: 4,
    },
    {
        label: '内容属性',
        value: 5,
    },
    {
        label: '仓储属性',
        value: 6,
    },
];

// 属性层级：新
export const levelTypeEnum = {
    1: '全国',
    2: '城市',
    3: '门店',
};

// 是否必填：旧和新通用
export const requiredTypeEnum = {
    YES: 1,
    NO: 0,
};
export const requiredTypeMap = {
    1: '是',
    0: '否',
};
export const requiredTypeOptions = [
    {
        label: '是',
        value: 1,
    },
    {
        label: '否',
        value: 0,
    },
];

// 库类型：旧和新通用
export const belongTypeEnum = {
    1: '基础库',
    2: '门店库',
};
export const belongTypeOptions = [
    {
        label: '基础库',
        value: 1,
    },
    {
        label: '门店库',
        value: 2,
    },
];

// 是否可展示：旧和新通用
export const displayAppFlagMap = {
    1: '是',
    0: '否',
};
export const displayAppFlagOptions = [
    {
        label: '是',
        value: 1,
    },
    {
        label: '否',
        value: 0,
    },
];
